import React from 'react';
import className from 'classnames';
import moment from 'moment';
import {get} from 'lodash';
import Modal from './Modal'
import { useModal } from '../hooks'
import { CSRF_TOKEN, requestCallback } from '../lib/helpers'
import { createTrustedDomain } from '../lib/api'
import axios from 'axios';

import {
  canEdit,
} from '../lib/policies';

import TableHeader from './TableHeader';
import ModalDelete from './ModalDelete';

const TrustedDomainsList = ({
  trustedDomains = [],
  total = 0,
}) => {
  const [
    createModal,
    createModalSet,
  ] = useModal({
    keyboardBindings: true,
  })

  const [
    deleteModal,
    deleteModalSet,
    $submitButton,
  ] = useModal({
    defaultValue: {
      isActive: false,
      domain: null,
    },
    keyboardBindings: true,
  })

  function removeUrl(domain) {
    requestCallback(axios.put(`/${gon.currentProvider}/api/trusted_domains/untrust`, {
      domain: domain,
      authenticity_token: CSRF_TOKEN
    }))
  }

  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Trusted Domains list</h2>
        </div>
        <div className='MainHeader__right'>
          <a
            className='MainHeader__right__a MainHeader__right__a--bright-blue'
            onClick={() => {
              createModalSet(true)
            }}
          >
            Add Domain
          </a>
        </div>
      </div>

      <div className='Table Table--trusted-domains-list'>
        {(() => {
          const columnHeaders = [
            {
              label: 'Domain'
            },
            {
              label: 'Admin'
            },
            {
              label: 'Create At'
            },
            {
              label: 'Manage',
            }
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}

        {trustedDomains.map((trustedDomain) => (
          <div
            className='Table__row'
            key={`${trustedDomain.domain}_${trustedDomain.createdAt}`}
            data-x={trustedDomain}
          >
            <div className='Table__col'>{trustedDomain.domain}</div>
            <div className='Table__col'>{trustedDomain.adminEmail}</div>

            <div
              className='Table__col'
              dangerouslySetInnerHTML={
                {
                  __html: trustedDomain.createdAt !== null ?
                    moment(trustedDomain.createdAt).format('YYYY-MM-DD<br />HH:mm')
                  :
                    'N/A'
                }
              }
            />

            <div className='Table__col'>
              <div className='Table__controls'>
                {canEdit('trustedDomain') &&
                  <a
                    className='Table__controls__a Table__controls__a--trash'
                    onClick={() => {
                      deleteModalSet({isActive: true, domain: trustedDomain.domain})
                    }}
                  >
                  </a>
                }
              </div>
            </div>
          </div>
        ))}
      </div>

      <Modal
        isActive={createModal}
        onToggleModal={() => {
          createModalSet(false)
        }}
      >
        <div className='BannedWordModal'>
          <h3 className='Modal__h3'>Add trusted domain</h3>

          <form
            className='BannedWordModal__form'
            onSubmit={(e) => {
              e.preventDefault()
              const $els = e.target.elements
              const domain = get($els, 'domain.value').trim()

              requestCallback(createTrustedDomain(domain))
            }}
          >
            <input
              type='text'
              className='Input'
              name='domain'
              placeholder='Domain'
              pattern='[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)'
              required
            />

            <div className='BannedWordModal__form__buttons'>
              <a
                className='Button Button--gray-light'
                onClick={() => {
                  createModalSet(false)
                }}
              >
                Cancel
              </a>

              <button className='Button Button--blue'>
                Add
              </button>
            </div>
          </form>
        </div>
      </Modal>

      <Modal
        isActive={deleteModal.isActive}
        onToggleModal={() => {
          deleteModalSet((prevState) => ({
            ...prevState,
            isActive: false
          }))
        }}
      >
        <div className='BannedWordModal'>
          <h3 className='Modal__h3'>Remove trusted domain</h3>

          <div className='Modal__p__wrapper'>
            <p className='Modal__p'>Are you sure you want to remove this domain?</p>
          </div>

          <div className='Modal__footer Modal__footer--without-border'>
            <a
              className='Button Button--gray-light'
              onClick={() => {
                deleteModalSet((prevState) => ({
                  ...prevState,
                  isActive: false
                }))
              }}
            >
              Cancel
            </a>

            <button
              className='Button Button--blue'
              onClick={() => { removeUrl(deleteModal.domain) }}
              ref={$submitButton}
            >
              Submit
            </button>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
}

export default TrustedDomainsList
